var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPersonIcon = function SvgPersonIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6978 33.3554C34.3896 29.401 30.6931 26.435 26.3192 25.0278C28.4146 23.7877 30.0428 21.8975 30.9536 19.6477C31.8645 17.398 32.0076 14.913 31.3611 12.5744C30.7145 10.2359 29.3141 8.17313 27.3748 6.70299C25.4355 5.23286 23.0646 4.43665 20.6264 4.43665C18.1881 4.43665 15.8172 5.23286 13.878 6.70299C11.9387 8.17313 10.5382 10.2359 9.89168 12.5744C9.24515 14.913 9.38829 17.398 10.2991 19.6477C11.21 21.8975 12.8381 23.7877 14.9335 25.0278C10.5597 26.435 6.86333 29.4008 4.55511 33.3551C4.44631 33.5422 4.38895 33.7544 4.38879 33.9705C4.38864 34.1866 4.4457 34.3989 4.55423 34.5861C4.66276 34.7733 4.81894 34.9287 5.00705 35.0368C5.19516 35.1449 5.40857 35.2018 5.6258 35.2018L35.6272 35.2021C35.8444 35.2021 36.0578 35.1452 36.2459 35.0371C36.434 34.9291 36.5902 34.7736 36.6988 34.5864C36.8073 34.3992 36.8643 34.1869 36.8642 33.9708C36.864 33.7547 36.8067 33.5425 36.6978 33.3554L36.6978 33.3554Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPersonIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PersonIcon.8f268d30.svg";
export { ForwardRef as ReactComponent };